// serverMeldung.ts — die Fehlermeldung des Servers lesbar machen.
//
// `apiFetch` wirft mit `HTTP <status>: <body>`, und der Body ist Nests
// JSON-Hülle: `{"message":"…","error":"Conflict","statusCode":409}`. Das
// Zahlungsverkehrs-Modul lehnt sich aber genau auf diese Texte — „KaV nicht
// möglich: Position ist storniert…", „Gebuchte Rechnung kann nicht gelöscht
// werden…". Roh angezeigt wäre der Satz zwar enthalten, aber in geschweiften
// Klammern und Anführungszeichen, mit Statuscode daneben.
//
// Bewusst hier statt in `apiFetch`: dort hängt die halbe Anwendung dran, und ein
// geänderter Fehlertext bricht Aufrufer, die auf das bisherige Format prüfen.

/** Holt den Klartext aus einem Fehler von `apiFetch`; sonst den Ersatztext. */
export function serverMeldung(fehler: unknown, ersatz: string): string {
  if (!(fehler instanceof Error) || !fehler.message) return ersatz;

  // `HTTP 409: {…}` → der JSON-Teil ab der ersten geschweiften Klammer.
  const start = fehler.message.indexOf("{");
  if (start >= 0) {
    try {
      const body = JSON.parse(fehler.message.slice(start)) as { message?: unknown };
      const text = Array.isArray(body.message) ? body.message.join(" · ") : body.message;
      if (typeof text === "string" && text.trim()) return text.trim();
    } catch {
      // Kein JSON — dann bleibt es beim Rohtext unten.
    }
  }

  // Kein Body, aber ein sprechender Status: „HTTP 403: Forbidden".
  if (/^HTTP \d+:\s*$/.test(fehler.message)) return ersatz;
  return fehler.message;
}
